export default {
  /**
   * 获取域名
   * 使用场景：通过域名获取对应的logo、title等运营商信息
   *
   * @returns {string} 域名
   */
  getHostname() {
    let url = new URL(location.href)
    return url.hostname
  }
}
